import { render, staticRenderFns } from "./productCategory.vue?vue&type=template&id=d1351742&scoped=true&"
import script from "./productCategory.vue?vue&type=script&lang=js&"
export * from "./productCategory.vue?vue&type=script&lang=js&"
import style0 from "./productCategory.vue?vue&type=style&index=0&id=d1351742&prod&lang=less&scoped=true&"
import style1 from "./productCategory.vue?vue&type=style&index=1&id=d1351742&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1351742",
  null
  
)

export default component.exports